export default __webpack_public_path__ + "static/media/header-banner.fdcd1708.png";